import { TextField } from '@mui/material';
import type React from 'react';
import { buildAnrokIntegrationEntityWithMetadata } from '@vy/services';
import { isEmptyString, isNotEmptyArray } from '@vy/utils';
import { Control, Controller } from 'react-hook-form';
import { CatalogProductsFormData } from '../../create-product-dialog-types';

type AnrokProductInputProps = {
  control: Control<CatalogProductsFormData>;
};

export const AnrokProductInput: React.FC<AnrokProductInputProps> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="anrokProduct"
      render={({ field }) => {
        const firstAnrokEntity = isNotEmptyArray(field.value) ? field.value[0] : undefined;
        const currentValue = firstAnrokEntity?.integrationExternalId ?? '';

        return (
          <TextField
            label="Anrok Product ID (Optional)"
            placeholder="Enter Anrok Product ID"
            fullWidth
            size="small"
            value={currentValue}
            onChange={(event) => {
              const productId = event.target.value;

              if (isEmptyString(productId)) {
                field.onChange(undefined);
                return;
              }

              const anrokEntity = buildAnrokIntegrationEntityWithMetadata(productId);
              field.onChange([anrokEntity]);
            }}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
        );
      }}
    />
  );
};
